export default __webpack_public_path__ + "static/media/politica-privacidade.7120c635.pdf";